import React, { useState } from 'react';
import { SectionWrapper } from './ui';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-dark-border last:border-b-0" data-id="element-18">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-19">
        <span className="text-lg md:text-xl font-bold text-white group-hover:text-primary transition-colors pr-4" data-id="element-20">
          {question}
        </span>
        <span className="text-primary shrink-0" data-id="element-21">
          {isOpen ? <ChevronUpIcon size={24} data-id="element-22" /> : <ChevronDownIcon size={24} data-id="element-23" />}
        </span>
      </button>
      <AnimatePresence data-id="element-24">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-25">
            <p className="pb-6 text-cyan-100/80 text-lg leading-relaxed" data-id="element-26">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si nunca usé IA antes?',
    a: 'Sí. El Bono 6 es específicamente el Plan de 7 Días para empezar desde cero sin abrumarte. Cada día tiene una microacción de 10 a 15 minutos. El Tomo 1 y el Bono 1 están diseñados para principiantes absolutos. No necesitás ningún conocimiento previo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de la compra recibís un mail con el link de descarga. En menos de 5 minutos tenés todo el material descargado en tu dispositivo. 100% PDF. Compatible con celular, tablet y computadora.'
  }, {
    q: '¿Necesito pagar herramientas de IA para usarlo?',
    a: 'No. Todos los prompts y sistemas del SUPERKIT IA funcionan con ChatGPT versión gratuita. No necesitás pagar ninguna suscripción adicional para implementar el 100% del material.'
  }, {
    q: '¿Sirve para mi rubro específico?',
    a: 'Sí. El SUPERKIT IA está diseñado para cualquier profesional, emprendedor o dueño de negocio que trabaje con texto, comunicación, análisis o gestión. Incluye la Biblioteca de Análisis por Industria con casos específicos para retail, servicios, gastronomía, profesionales de la salud y más.'
  }, {
    q: '¿Qué diferencia hay entre el SUPERKIT IA y El Arquitecto?',
    a: 'El SUPERKIT IA (6 Tomos + 6 Bonos) te convierte en un Operador Avanzado: usás la IA para tareas cotidianas y ahorrás entre 2 y 4 horas por día. El Arquitecto te lleva al siguiente nivel: construís sistemas donde la IA opera procesos completos con 5 Agentes Personalizados, flujos encadenados y prompts de nivel consultoría que resuelven desafíos estratégicos de todo un trimestre.'
  }, {
    q: '¿Funciona en cualquier parte de Argentina?',
    a: 'Sí. Todo el material está adaptado al contexto económico, legal y cultural argentino. Precios en ARS, referencias al mercado local, ejemplos con casos de ciudades argentinas y consideraciones del contexto inflacionario.'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-30">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-31">
          {faqs.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} data-id="element-32" />)}
        </div>
      </div>
    </SectionWrapper>;
};